export const IncentivesManagerIcon = () => (
    <img className='w-8 h-8' src={`${window.location.origin}/icons/28px_IM.svg`} alt="Incentives Manager" />
);
